import Vue from 'vue'
import App from './App.vue'
import Notifications from "vue-notification";
import store from './store.js';
import router from './router/router';

import VueEditor from 'vue2-editor'
import Quill from 'vue2-editor'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import VueImg from 'v-img';
import JsonExcel from 'vue-json-excel'
import 'dotenv/config'
import { sendRequest, sendRequestAuth } from './api/client';

Vue.component('downloadExcel', JsonExcel)

const vueImgConfig = {
  // Consider alt of image as its title in gallery?
  altAsTitle: false,
}
Vue.use(VueImg, vueImgConfig);


Vue.config.productionTip = false
Vue.use(Notifications);

const requestBase =
  process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_REQUEST_URL.replace(/\/+$/, '')
    : '';

window.url = requestBase + "/backEnd/request.php";
window.url2 = requestBase + "/backEnd/request_auth.php";
window.sendRequest = sendRequest;
window.sendRequestAuth = sendRequestAuth;


window.soundClick = function () {
  var audio = new Audio(); // Создаём новый элемент Audi
  audio.src = 'file/click.mp3'; // Указываем путь к звуку "клика"
  audio.volume = 0.2; // Громкость
  audio.autoplay = true; // Автоматически запускаем
}

Vue.component('v-select', vSelect)

new Vue({
  render: h => h(App),
  store,
  router,
  VueEditor,
  Quill,
}).$mount('#app')
